import { getCountryObjectFromCache } from ".";
import { getLanguageForCountryCode } from "./i18n";

const TRANSIFEX_LINKS = {
  backend: (code: string) =>
    `https://app.transifex.com/un-wfp/farm2go-backend/translate/#${code}/farm2go_backend/414717885`,
  mobile: (code: string) =>
    `https://app.transifex.com/un-wfp/farm2go-mobile-app/translate/#${code}/Mobile_en/409966909`,
  web: (code: string) =>
    `https://app.transifex.com/un-wfp/farm2go-web/translate/#${code}/translation/418195449`,
};

export type TransifexLinkType = keyof typeof TRANSIFEX_LINKS;

interface CountryCacheObject {
  code?: string;
  name?: string;
}

export const getCachedCountry = (): CountryCacheObject => {
  const country = getCountryObjectFromCache() as CountryCacheObject | null | undefined;

  return country ?? {};
};

export const getTransifexLink = (type: TransifexLinkType): string | null => {
  const country = getCachedCountry();

  if (!country.code) {
    return null;
  }

  const language = getLanguageForCountryCode(country.code);

  if (!language) {
    return null;
  }

  return TRANSIFEX_LINKS[type](language.value);
};
